import { render, staticRenderFns } from "./el-sendGroup.vue?vue&type=template&id=1e54a5f6&scoped=true"
import script from "./el-sendGroup.vue?vue&type=script&lang=js"
export * from "./el-sendGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e54a5f6",
  null
  
)

export default component.exports